// Registers the production service worker. Deliberately a no-op in development,
// where a cached app shell would serve stale bundles.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname)
);

type Config = {
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;

          installing.onstatechange = () => {
            if (installing.state !== 'installed') return;

            if (navigator.serviceWorker.controller) {
              // Older content is still being served by the active worker.
              config?.onUpdate?.(registration);
            } else {
              config?.onSuccess?.(registration);
            }
          };
        };
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });

    if (isLocalhost) {
      navigator.serviceWorker.ready.then(() => {
        console.log('App is being served cache-first by a service worker.');
      });
    }
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error));
}
